import IconCopy from '@creditflowresearch/uilib/Icon/IconCopy';
import IconPencil from '@creditflowresearch/uilib/Icon/IconPencil';
import { useCopyToClipboard } from '@dealroadshow/uikit-hooks/useCopyToClipboard';
import styles from '../askAiChat.module.scss';

interface IMessageActionsProps {
  content: string,
  onEdit: () => void,
}

const MessageActions = ({ content, onEdit }: IMessageActionsProps) => {
  const [copy] = useCopyToClipboard();

  return (
    <div className={ styles.messageActions }>
      <span className={ styles.messageActionsLabel }>Response:</span>
      <button
        type="button"
        className={ styles.actionButton }
        onClick={ () => copy(content) }
        aria-label="Copy response"
        data-test="askAiChatCopyResponse"
      >
        <IconCopy size={ 12 } />
      </button>
      <button
        type="button"
        className={ styles.actionButton }
        onClick={ onEdit }
        aria-label="Edit request"
        data-test="askAiChatEditResponse"
      >
        <IconPencil size={ 12 } />
      </button>
    </div>
  );
};

export default MessageActions;
